import EmptyIcon from '@/assets/images/not-found.svg'
import { Card } from '@/components/ui/card.tsx'
import { convertMinutes } from '@/modules/tracking/new-subscriber-analysis/ui/helpers/convertMinutes.ts'

interface Props {
  isFetching: boolean
  repliedSubscribers: number
  time: number
}
export const AverageResponseTime = ({
  isFetching,
  repliedSubscribers,
  time,
}: Props) => {
  if (isFetching) {
    return <div className="h-72  animate-pulse rounded-md bg-skeleton" />
  }

  const responseTime = convertMinutes(time)

  return (
    <Card className="flex h-72 flex-col justify-between p-6 sm:h-auto">
      <div className="text-xl font-semibold leading-none">
        Average Response Time
      </div>

      {repliedSubscribers ? (
        <>
          <div>
            <span className="text-2xl font-semibold leading-none">
              {responseTime.value}
            </span>{' '}
            <span className="text-secondary-400">{responseTime.format}</span>
          </div>

          <div className="text-sm">
            From {repliedSubscribers} Subscribers That Replied
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center gap-3 text-center">
          <EmptyIcon />
          <p>You do not have any data for this period.</p>
        </div>
      )}
    </Card>
  )
}
